import { cn } from "ui";

import { type CustomYouTubeProps } from "./YouTube";

type YouTubeFallbackProps = Pick<
  CustomYouTubeProps,
  "width" | "height" | "className" | "fallbackClassName"
>;

export function YouTubeFallback(props: YouTubeFallbackProps) {
  return (
    <div
      className={cn(
        "w-full h-[480px] bg-slate-300 rounded-[4px]",
        props.className,
        props.fallbackClassName,
      )}
    />
  );
}
